module.exports = __webpack_public_path__ + "components/outside-promo-page/static/google-599c964334b7fc772a616a9b1d4cfd55.png";